import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const getStatusCode = (error: unknown): number | undefined => {
  if (isAxiosError(error)) {
    return error.response?.status;
  }
  const message = (error as { message?: unknown } | null)?.message;
  if (typeof message === 'string') {
    const match = /status code (\d+)/.exec(message);
    if (match) {
      return Number(match[1]);
    }
  }
  return undefined;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: 1500,
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      retry: (failureCount, error) => {
        // handles API timeouts, status code is not returned
        if (error.message.includes('Network Error')) {
          // return false to not retry a fetch request, it takes 30+ seconds and looks like an infinite spinning loader component
          return false;
        }
        const status = getStatusCode(error);
        if (status === 403) {
          return failureCount < 1;
        }
        if (status === 401) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});

export default queryClient;
